export default "__VITE_ASSET__Dz0CYjp$__"